"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTPSLErrorStringId = exports.OrderPriceFiledLimitErrorMap = exports.OrderPriceFieldErrorMap = exports.TradeLimitErrorMessageMap = exports.ErrorMessageMap = void 0;
const TPSLUtils_1 = require("./TPSLUtils");
exports.ErrorMessageMap = {
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_LATEST]: "tp_error_lt_latest",
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_MARK]: "tp_error_lt_mark",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_GT_LATEST]: "sl_error_gt_latest",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_GT_MARK]: "sl_error_gt_mark",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_LT_LIQ_PRICE]: "sl_error_lt_liq_price",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_LATEST]: "tp_error_gt_latest",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_MARK]: "tp_error_gt_mark",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_LT_LATEST]: "sl_error_lt_latest",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_LT_MARK]: "sl_error_lt_mark",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_GT_LIQ_PRICE]: "sl_error_gt_liq_price",
    [TPSLUtils_1.TPSLErrorCode.INVALID_CURRENT_PRICE]: "tp_sl_error_invalid_current_price",
    [TPSLUtils_1.TPSLErrorCode.INVALID_PRICE]: "tp_sl_error_invalid_trigger_price",
    [TPSLUtils_1.TPSLErrorCode.INVALID_PRICE_LT_ZERO]: "tp_sl_error_trigger_price_lt_zero",
    [TPSLUtils_1.TPSLErrorCode.INVALID_MARK_PRICE]: "tp_sl_invalid_mark_price",
    [TPSLUtils_1.TPSLErrorCode.INVALID_CLOSE_AMOUNT]: "error_setting_close_amount",
    [TPSLUtils_1.TPSLErrorCode.INVALID_CLOSE_AMOUNT_GT_MAX]: "error_setting_close_max_amount",
    [TPSLUtils_1.TPSLErrorCode.INVALID_TOP_OR_BOTTOM_PRICE]: "invalid_top_or_bottom_price",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_GTE_BOTTOM_PRICE]: "long_sl_gte_bottom_price",
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LTE_TOP_PRICE]: "long_tp_lte_top_price",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_LTE_TOP_PRICE]: "short_sl_lte_top_price",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GTE_BOTTOM_PRICE]: "short_tp_gte_bottom_price",
    [TPSLUtils_1.TPSLErrorCode.SL_LIQ_OFFSET_LIMIT]: "sl_liq_offset_limit",
    [TPSLUtils_1.TPSLErrorCode.INVALID_TRIGGER_LIMIT_PRICE]: "invalid_trigger_limit_price",
};
exports.TradeLimitErrorMessageMap = {
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_LATEST]: "tp_error_lt_limit",
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_LIMIT]: "tp_error_lt_limit",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_GT_LATEST]: "sl_error_gt_limit",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_LATEST]: "tp_error_gt_limit",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_LIMIT]: "tp_error_gt_limit",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_LT_LATEST]: "sl_error_lt_limit",
    [TPSLUtils_1.TPSLErrorCode.INVALID_CURRENT_PRICE]: "tp_sl_error_invalid_limit_price",
    [TPSLUtils_1.TPSLErrorCode.LIMIT_LONG_SL_GT_LATEST]: "limit_sl_error_gt_cur_price",
    [TPSLUtils_1.TPSLErrorCode.LIMIT_SHORT_SL_LT_LATEST]: "limit_sl_error_lt_cur_price",
};
/**非限价单，按限价设置止盈止损时对应的错误文案 */
exports.OrderPriceFieldErrorMap = {
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_LATEST]: "order_tp_error_lt_latest",
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_MARK]: "order_tp_error_lt_mark",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_GT_LATEST]: "order_sl_error_gt_latest",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_GT_MARK]: "order_sl_error_gt_mark",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_LT_LIQ_PRICE]: "order_sl_error_lt_liq_price",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_LATEST]: "order_tp_error_gt_latest",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_MARK]: "order_tp_error_gt_mark",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_LT_LATEST]: "order_sl_error_lt_latest",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_LT_MARK]: "order_sl_error_lt_mark",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_GT_LIQ_PRICE]: "order_sl_error_gt_liq_price",
};
/**限价单，按限价设置止盈止损时对应的错误文案 */
exports.OrderPriceFiledLimitErrorMap = {
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_LATEST]: "order_price_error_lt_limit",
    [TPSLUtils_1.TPSLErrorCode.LONG_TP_LT_LIMIT]: "order_price_error_lt_limit",
    [TPSLUtils_1.TPSLErrorCode.LONG_SL_GT_LATEST]: "order_price_error_gt_limit",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_LATEST]: "order_price_error_gt_limit",
    [TPSLUtils_1.TPSLErrorCode.SHORT_TP_GT_LIMIT]: "order_price_error_gt_limit",
    [TPSLUtils_1.TPSLErrorCode.SHORT_SL_LT_LATEST]: "order_price_error_lt_limit",
    [TPSLUtils_1.TPSLErrorCode.INVALID_CURRENT_PRICE]: "tp_sl_error_invalid_limit_price",
    [TPSLUtils_1.TPSLErrorCode.LIMIT_LONG_SL_GT_LATEST]: "limit_sl_error_gt_cur_price",
    [TPSLUtils_1.TPSLErrorCode.LIMIT_SHORT_SL_LT_LATEST]: "limit_sl_error_lt_cur_price",
};
function getTPSLErrorStringId(error, isTradeLimit = false) {
    const { code, field } = error;
    if (field === TPSLUtils_1.ErrorFiledName.OrderPriceField) {
        if (isTradeLimit) {
            return exports.OrderPriceFiledLimitErrorMap[code] || exports.ErrorMessageMap[code];
        }
        return exports.OrderPriceFieldErrorMap[code] || exports.ErrorMessageMap[code];
    }
    return isTradeLimit ? exports.TradeLimitErrorMessageMap[code] || exports.ErrorMessageMap[code] : exports.ErrorMessageMap[code];
}
exports.getTPSLErrorStringId = getTPSLErrorStringId;
